import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "balance" }
const _hoisted_2 = { class: "balance-header flex-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "header-title header-5" }, "Balance", -1 /* HOISTED */)
const _hoisted_4 = { class: "current-balance" }
const _hoisted_5 = { class: "balance-total-column" }
const _hoisted_6 = { class: "currency" }
const _hoisted_7 = { class: "amount" }
const _hoisted_8 = { class: "balance-description-column" }
const _hoisted_9 = { class: "pending-container" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "pending-header" }, "Pending", -1 /* HOISTED */)
const _hoisted_11 = { class: "pending-total" }
const _hoisted_12 = { class: "amount" }
const _hoisted_13 = { class: "available-container" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "available-header" }, "Available", -1 /* HOISTED */)
const _hoisted_15 = { class: "available-total" }
const _hoisted_16 = { class: "amount" }
const _hoisted_17 = { class: "balance-history" }
const _hoisted_18 = { class: "transaction-header" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", null, "Transaction History", -1 /* HOISTED */)
const _hoisted_20 = { class: "transaction" }
const _hoisted_21 = { class: "date" }
const _hoisted_22 = { class: "from" }
const _hoisted_23 = {
  key: 0,
  class: "amount isNegative"
}
const _hoisted_24 = {
  key: 1,
  class: "amount"
}
const _hoisted_25 = { class: "status" }
const _hoisted_26 = { class: "transaction" }
const _hoisted_27 = { class: "date" }
const _hoisted_28 = { class: "from" }
const _hoisted_29 = {
  key: 0,
  class: "amount isNegative"
}
const _hoisted_30 = {
  key: 1,
  class: "amount"
}
const _hoisted_31 = {
  key: 2,
  class: "status"
}
const _hoisted_32 = {
  key: 3,
  class: "status"
}
const _hoisted_33 = { class: "bottom-balance" }
const _hoisted_34 = { class: "btn-container balance-bottom" }
const _hoisted_35 = {
  key: 0,
  class: "loading-container flex-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "borderless profile-back-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goTo('/')))
      }, "Home"),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["balance-total", { negative: $setup.balances.eventual.value < 0 , zero: $setup.balances.eventual.value == 0 , ten: $setup.balances.eventual.value < 100 && $setup.balances.eventual.value > 0, hundred: $setup.balances.eventual.value < 1000 && $setup.balances.eventual.value >= 100 , thousand: $setup.balances.eventual.value < 10000 && $setup.balances.eventual.value >=1000 , tenthousand: $setup.balances.eventual.value >= 10000}])
        }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString($setup.balances.eventual.value < 0 ? '-' : '') + "$", 1 /* TEXT */),
          _createElementVNode("span", _hoisted_7, _toDisplayString(Math.abs($setup.balances.eventual.value).toFixed(2)), 1 /* TEXT */)
        ], 2 /* CLASS */)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, "$" + _toDisplayString($setup.balances.pending.value.toFixed(2)), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, "$" + _toDisplayString(Math.abs($setup.balances.available.value).toFixed(2)), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", { class: "withdraw-container" }, [
          _createElementVNode("button", {
            class: "outline withdrawBtn",
            onClick: $setup.moveToWithdraw
          }, " Withdraw")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        ($setup.env === 'dev' || $setup.env === 'development')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.hideTransfers = !$setup.hideTransfers))
            }, _toDisplayString($setup.hideTransfers ? "Hiding" : 'Showing') + " Transfers", 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.hideTransfers)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.filteredTransactions, (transaction) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", {
                class: _normalizeClass(["transaction-container", { pending: transaction.status === 'pending', posted: transaction.status == 'posted', failed: transaction.status == 'failed', canceled: transaction.status == 'canceled' }])
              }, [
                _createElementVNode("div", _hoisted_21, _toDisplayString($setup.interpretTime(transaction.createdAt)), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_22, _toDisplayString($setup.resolveTransactionName(transaction)), 1 /* TEXT */),
                (transaction.source.scope===$setup.currentUser.$id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, "-$" + _toDisplayString(Math.abs(transaction.amount).toFixed(2)), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, "$" + _toDisplayString(Math.abs(transaction.amount).toFixed(2)), 1 /* TEXT */)),
                _createElementVNode("div", _hoisted_25, _toDisplayString(transaction.status), 1 /* TEXT */)
              ], 2 /* CLASS */)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.transactions, (transaction) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", {
                class: _normalizeClass(["transaction-container", { pending: transaction.status === 'pending', posted: transaction.status == 'posted', failed: transaction.status == 'failed', canceled: transaction.status == 'canceled' }])
              }, [
                _createElementVNode("div", _hoisted_27, _toDisplayString($setup.interpretTime(transaction.createdAt)), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_28, _toDisplayString($setup.resolveTransactionName(transaction)), 1 /* TEXT */),
                (transaction.source.scope===$setup.currentUser.$id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, "-$" + _toDisplayString(Math.abs(transaction.gross).toFixed(2)), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("div", _hoisted_30, "$" + _toDisplayString(Math.abs(transaction.amount).toFixed(2)), 1 /* TEXT */)),
                (transaction.source.scope===$setup.currentUser.$id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString($setup.payerTransactionStatusMap[transaction.status]), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString($setup.collectorTransactionStatusMap[transaction.status]), 1 /* TEXT */))
              ], 2 /* CLASS */)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("button", {
          class: "primary profile-btn sendInvite",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goTo('/links')))
        }, "Meeting Types")
      ])
    ]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createVNode($setup["VLoader"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}